<template>
    <div>
        <div class="form__field">
            <div class="form__input d-flex">
                <input
                        v-model="keyword"
                        @keyup.enter.stop.prevent="addKeyword"
                        name="keyword"
                        id="keyword"
                        type="text">
                <button type="button" class="button button--small button--ghost" style="margin-left: 10px" @click="addKeyword">
                    Add
                </button>
            </div>
        </div>

        <div class="mb-10">
            <span v-for="keyword in currentKeywords" :key="keyword" class="keyword-list">
                {{ keyword }}
                <span @click.prevent.stop="removeKeyword(keyword)" class="keyword-list__close">x</span>
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';

export default defineComponent({
    data() {
        return {
            keyword: '',
            currentKeywords: [] as string[],
        };
    },
    props: {
        keywords: {type: Array as PropType<string[]>, default: () => []},
    },
    methods: {
        addKeyword() {
            if (this.keyword === null || this.keyword === '' || this.currentKeywords.includes(this.keyword)) {
                return;
            }

            this.currentKeywords.push(this.keyword);
            this.keyword = '';
            this.$emit('update', this.currentKeywords);
        },
        removeKeyword(keyword: string) {
            const index = this.currentKeywords.indexOf(keyword);
            this.currentKeywords.splice(index, 1);
            this.$emit('update', this.currentKeywords);
        },
    },
    watch: {
        keywords() {
            this.currentKeywords = this.keywords;
        },
    },
});
</script>
